import MultiAttorneyAvatarsSvg from "src/images/inhouseLawyers.png";
const SIZE_CLASSES = {
  sm: "h-5 w-auto",
  md: "h-8 w-auto",
  lg: "h-8 md:h-9 w-auto",
};

const MultiAttorneyAvatars = ({ size = "md", className = "" }) => {
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <img
      src={MultiAttorneyAvatarsSvg}
      alt=""
      aria-hidden="true"
      className={`mr-1 md:mr-3 shrink-0 ${sizeCls} ${className}`.trim()}
    />
  );
};

export default MultiAttorneyAvatars;
